<template>
    <h1>Seite wurde nicht gefunden!</h1>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>